<template>
    <div>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li>关于我们</li>
                <li>云验证介绍</li>
            </ul>
        </div>
        <div class="mainindex">
            <div class="welinfo">
                <div style="text-align:center;">
                    <strong style="font-size: 18px;color:rgb(100, 164, 248)">关于云验证</strong>
                    <!-- <label style="font-size: 18px;color:red;margin-left:10px;">8年：一直在努力，用心去服务</label> -->
                    <el-button type="danger" style="margin-left:15px;letter-spacing: 1px;" @click="reg()" >注册用户</el-button>
                </div>
                <ul class="infolist">
                    <li>
                        <b style="font-size: 15px;color:red;">14年：一直在努力，用心去服务</b>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（1）14年来拥有国内外130万用户，近1500个API合作伙伴;</span>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（2）已获4款软件著作权；3组商标;</span>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（3）成为了阿里B2B, 淘宝天下、天下网商、卖家、阿里会展、新浪乐居、百度乐居、腾讯乐居、快钱、广交会、新浪微博电商、挖财、车蚂蚁 车纷享、又拍云、51信用卡、杭州云计算协会、杭州物联网协会、杭州电子商务协会、西湖区农业局、杭州机动车管理处…等的官方伙伴或供应商;</span>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（4）《淘宝天下》《卖家》 《天下网商》 杂志2012－2014官方合作伙伴;</span>
                    </li>

                    <li>
                        <span style="margin-left: 20px;">（5）经过阿里巴巴考核检验，产品内嵌至阿里内部系统，供其诚信通等上千员工每天使用;</span>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（6）2012 首届“湾云杯”全国云计算设计应用大赛 三等奖</span>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（7）累计淘宝2万多卖家选用，并已进入京东、当当、风云在线、神码等平台;</span>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（8）2008－2010年，曾在阿里软件alisoft前TOP10产品占3，在前TOP20产品占4，因用户众多，嵌入过淘宝旺旺;</span>
                    </li>

                    <li>
                        <span style="margin-left: 20px;">（9）入驻国家中小企业信息化公共云服务平台;</span>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（10）2009年，入选福布斯.杭州商业模式创新论坛及《商业模式创新理论与实践》;</span>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（11）累计交易6万笔订单，支付宝特约商家满意度99.9985%...这是我们最为看重的;</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="xline"></div>
    </div>
</template>

<script>
export default {
    methods:{
        reg() {
            window.open("reg");
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/shouye/aboutusdescription/2officeintroduction.vue